import type { MutableRefObject } from 'react';
import { useMemo, useRef } from 'react';

type DebounceRef = MutableRefObject<ReturnType<typeof setTimeout> | null>;

export function useDebounceCallback(): [
	(callback: () => unknown, ms: number) => void,
	() => void,
	DebounceRef,
] {
	const timeout = useRef<ReturnType<typeof setTimeout> | null>(null);

	return useMemo(
		() => [
			(callback, ms) => {
				if (timeout.current) {
					clearTimeout(timeout.current);
				}

				timeout.current = setTimeout(() => {
					void callback();
					timeout.current = null;
				}, ms);
			},
			() => {
				if (timeout.current) {
					clearTimeout(timeout.current);
					timeout.current = null;
				}
			},
			timeout,
		],
		[]
	);
}
